(() => {
  const params = new URLSearchParams(location.search);
  if (params.has('case') || params.get('source') !== 'product-detail') return;
  const root = document.querySelector('[data-contact-page]');
  const form = root?.querySelector('#ContactUsForm');
  const panel = form?.querySelector('[data-product-inquiry-panel]');
  if (!panel) return;
  const node = selector => panel.querySelector(selector);
  const copy = JSON.parse(document.querySelector('[data-product-inquiry-copy]').textContent);
  const status = form.querySelector('[data-product-inquiry-status]');
  const summary = node('[data-product-inquiry-summary]');
  const link = node('[data-product-inquiry-link]');
  const choose = form.querySelector('[data-product-inquiry-choose]');
  const summaryInput = node('[data-product-inquiry-value]');
  const linkInput = node('[data-product-inquiry-url]');
  const card = node('[data-product-inquiry-card]');
  const image = node('[data-product-inquiry-image]');
  const placeholder = node('[data-product-inquiry-placeholder]');
  const subject = form.querySelector('[name="contact[Subject]"]');
  const source = form.querySelector('[name="contact[Source]"]');
  const originalSource = source.value;
  const content = window.PoptexTemplateContent;
  const products = window.PoptexProductContent;
  let removed = false;
  let dispose;
  const setText = (selector, value) => {
    const target = node(selector);
    if (target && target.textContent !== value) target.textContent = value;
  };
  const clearImage = () => {
    if (!image) return;
    image.hidden = true;
    image.alt = '';
    if (content) content.setImage(image, placeholder, '');
    else image.removeAttribute('src');
  };
  const clearSelection = () => {
    source.value = originalSource;
    summary.hidden = true;
    summary.textContent = '';
    link.hidden = true;
    link.removeAttribute('href');
    if (card) card.hidden = true;
    clearImage();
    for (const input of [summaryInput, linkInput]) { input.value = ''; input.disabled = true; }
  };
  const unavailable = () => {
    clearSelection();
    status.hidden = false;
    status.textContent = copy.unavailable;
    choose.hidden = false;
  };
  panel.hidden = false;
  if (card) card.hidden = true;
  status.hidden = false;
  status.textContent = copy.loading;
  node('[data-product-inquiry-remove]')?.addEventListener('click', () => {
    removed = true;
    dispose?.();
    const url = new URL(location.href);
    for (const key of ['source', 'product', 'pattern', 'size']) url.searchParams.delete(key);
    url.hash = '';
    history.replaceState(null, '', url);
    clearSelection();
    panel.hidden = true;
    status.hidden = true;
    choose.hidden = true;
    const announcement = root.querySelector('[data-product-inquiry-announcement]');
    if (announcement) announcement.textContent = copy.removed;
    form.querySelector('[name="contact[name]"]')?.focus();
  });
  if (!content || !products) { unavailable(); return; }
  dispose = content.watch(root, (snapshot, settled) => {
    if (removed || (!snapshot && !settled)) return;
    try {
      const result = products.resolve(snapshot, { style: params.get('product'), template: params.get('pattern') });
      if (!params.get('product') || result.kind !== 'detail') { unavailable(); return; }
      const sizeKey = params.get('size');
      const size = (Array.isArray(result.style.sizes) ? result.style.sizes : []).find(item =>
        Number(item.widthInches) > 0 && Number(item.heightInches) > 0 && `${item.widthInches}x${item.heightInches}` === sizeKey);
      if (params.has('size') && !size) { unavailable(); return; }
      const sizeText = size ? copy.size_value.replace('__WIDTH__', size.widthInches).replace('__HEIGHT__', size.heightInches) : copy.no_size;
      const text = [
        `${copy.collection}: ${result.group.name}`,
        `${copy.style}: ${result.style.name}`,
        `${copy.pattern}: ${result.template?.name || copy.no_pattern}`,
        `${copy.size}: ${sizeText}`
      ].join('\n');
      const url = new URL(products.publicUrl(root.dataset.rootUrl, result.state), location.origin);
      if (size) url.searchParams.set('size', sizeKey);
      for (const key of ['preview_theme_id', 'preview_key', '_fd', 'pb']) {
        if (params.has(key)) url.searchParams.set(key, params.get(key));
      }
      setText('[data-product-inquiry-collection]', copy.product_label);
      setText('[data-product-inquiry-name]', result.style.name);
      setText('[data-product-inquiry-pattern]', result.template?.name || copy.no_pattern);
      setText('[data-product-inquiry-size]', sizeText);
      const patternRow = node('[data-product-inquiry-pattern-row]');
      const sizeRow = node('[data-product-inquiry-size-row]');
      if (patternRow) patternRow.hidden = !result.template?.name;
      if (sizeRow) sizeRow.hidden = !size;
      if (image) {
        const styleGallery = products.gallery(result.style.detailGallery, result.style.name);
        const styleImage = products.safeUrl(result.style.effectUrl) || products.safeUrl(result.style.coverUrl)
          || styleGallery.find(item => item.role === 'PRODUCT')?.url || styleGallery[0]?.url || '';
        const imageUrl = products.safeUrl(content.productPreview(result.template)?.url) || styleImage;
        image.alt = result.template
          ? copy.image_alt.replace('__NAME__', result.style.name).replace('__PATTERN__', result.template.name)
          : result.style.name;
        if (image.getAttribute('src') !== imageUrl) image.hidden = true;
        content.setImage(image, placeholder, imageUrl);
      }
      status.hidden = true;
      summary.hidden = false;
      summary.textContent = text;
      if (card) card.hidden = false;
      link.hidden = false;
      link.href = url.href;
      choose.hidden = true;
      summaryInput.disabled = false;
      summaryInput.value = text;
      linkInput.disabled = false;
      linkInput.value = url.href;
      source.value = 'Product detail page';
      if (!subject.value) subject.value = 'Custom quote';
    } catch {
      unavailable();
    }
  });
})();
